/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { SoundIcon, UnitIcon, UnitRightIcon } from "@/icons";
import "./BookSounds.scss";
import MediaPlayer, { mediaTypes } from "@/components/media-player/mediaplayer";
import { PageCanvasService } from "@/database/smartBookModelService";

interface BookSoundsProps {
  bookSounds: any[];
  bookId: number;
}

const BookSounds: React.FC<BookSoundsProps> = ({ bookId, bookSounds }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'book_detail' });
  const [activeUnit, setActiveUnit] = useState<any | null>(null);
  const [selectedSound, setSelectedSound] = useState<any | null>(null);

  useEffect(() => {
    if (bookSounds.length > 0) {
      const firstUnitWithItems = bookSounds.find(
        (unit) => unit.items?.length > 0
      );
      if (firstUnitWithItems) {
        setActiveUnit(firstUnitWithItems);
      }
    }
  }, [bookSounds]);

  const openSound = async (activity: any) => {
    const activityPath = await PageCanvasService.getActivityPath(
      bookId,
      activity.id,
      activity
    );

    setSelectedSound({ ...activity, path: activityPath });
  };
  if (!activeUnit) return null;

  return (
    <div className="book-sound-wrapper">
      <div className="book-sound-container">
        <div className="book-sound-sidebar">
          <div className="sidebar-header">
            <UnitIcon className="unit-icon" />
            <span>{t("units")}</span>
          </div>

          <div className="unit-list">
            {bookSounds.map((unit) => {
              if (!unit.items?.length) return null;

              return (
                <div
                  key={unit.id}
                  className={`unit-item ${activeUnit.id === unit.id ? "active" : ""}`}
                  onClick={() => setActiveUnit(unit)}
                >
                  <div className="unit-info">
                    <div className="unit-icon-wrapper">
                      <UnitIcon className="unit-icon" />
                    </div>
                    <div className="unit-text">
                      <span className="unit-title">{unit.title}</span>
                      <div className="unit-meta">
                        <span className="unit-count">
                          {unit.items.length} sounds
                        </span>
                      </div>
                    </div>
                  </div>
                  <UnitRightIcon className="arrow-icon" />
                </div>
              );
            })}
          </div>
        </div>

        <div className="book-sound-content">
          <div className="content-main">
            <div className="content-header">
              <div className="header-title">
                <SoundIcon className="sound-icon" />
                <h2>{activeUnit.title}</h2>
              </div>
              <span className="sound-count">
                {activeUnit.items.length} Sesler
              </span>
            </div>

            <div className="sound-grid">
              {activeUnit.items.map((sound: any) => (
                <div
                  key={sound.id}
                  className={`sound-card ${selectedSound?.id === sound.id ? "active" : ""}`}
                  onClick={() => openSound(sound)}
                >
                  <div className="sound-card-content">
                    <SoundIcon className="sound-icon" />
                    <span className="sound-title">{sound.title}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="content-player">
            <div className="player-header">
              <span className="now-playing">{selectedSound?.title}</span>
            </div>
            {selectedSound && (
              <MediaPlayer
                url={selectedSound.path}
                type={mediaTypes.audio}
                transcript={selectedSound.transcript}
                title={undefined}
                footer={undefined}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookSounds;
